import {
  TTransferQuantity,
} from '../../../types';

const INITIAL_FORM: TTransferQuantity = {
  selectetVariant: null,
  targetLocation: null,
  quantity: 0,
  selectedQuantityType: null,
};

export {
  INITIAL_FORM,
};
